import api, { baseURL } from "../../../../utils/api"

export const getAllVendors = (page, limit, searchQuery, fromDate = null, toDate = null) =>{
	let url = `${baseURL}/user/allvendors?search=${searchQuery ? searchQuery : ""}&page=${page}&size=${limit}`;
	if (fromDate) {
		url += `&fromDate=${fromDate}`;
	}
	if (toDate) {
		url += `&toDate=${toDate}`;
	}
	return api.get(url);
}

export const getVendorChildUsers = (page, limit, searchQuery, userId, fromDate = null, toDate = null) =>{
	let url = `${baseURL}/user/fetch/childusers?search=${searchQuery ? searchQuery : ""}&page=${page}&size=${limit}&user_id=${userId}`;
	if (fromDate) {
		url += `&fromDate=${fromDate}`;
	}
	if (toDate) {
		url += `&toDate=${toDate}`;
	}
	return api.get(url);
}

export const getVendorClientList = (id, userType) => {
	return api.get(`${baseURL}/user/allvendors/${id}/${userType}`);
}

export const deleteVendor = (vendorId) =>{
	return api.delete(`${baseURL}/user/deleteuser?id=${vendorId}`);
}
export const addVendorManually = (formData) => {
  return api.post(`${baseURL}/auth/addClientOrVendorManuallyFromCms`, formData);
};
export const checkemailexist = (formData) => {
  return api.post(`${baseURL}/auth/checkemailexist`, formData);
};
export const vendorListHeaders = [
	"Sr.",
  "Date/Time Created",
  "Name",
  "Username",
  // "ClientList",
  // "VendorList",
  // "ResourceList",
  "Email ID",
  "Country",
  "Mobile Number",
  // "Company",
  // "Status",
  // "Self Managed Resources",
  // "Action"
]

export const VendorClientConnectionsHeaders = [
  "Sr.",
  "Name",
]
